<template>
    <div>
        <loading :active.sync="loading" :can-cancel="false" :is-full-page="true"
            :height="150" :width="150" :color="'#FFFF00'" :background-color="'#000000'" :opacity="0.5">
        </loading>
        <div v-if="!loading">
            <!-- Back button sticky at top of outer card -->
            <div class="ca-back-bar">
                <v-btn color="warning" style="width:100px;" @click="goBack()">
                    {{$t('button.back')}}
                </v-btn>
            </div>
            <!-- Scrollable content -->
            <div class="ca-scroll-content">
                <app-claim-details
                    v-bind:claimrecordItems="this.claimrecordItems"
                    v-on:claim-display-details="routeClaimDetails"
                />
            </div>
        </div>
    </div>
</template>

<script>

import Loading from "vue-loading-overlay";
import ClaimDetails from '../../sscomponents/claimapproval/ClaimDetails.vue'
import moment from 'moment'

export default {

    components: {
        "app-claim-details": ClaimDetails,
        Loading
    },

    data() {
        return {
            loading: false,
            claimRecord: [],
            claimrecordItems: []
        }
    },

    methods: {
        goBack() {
            this.$router.push({name: 'selfservicemytask'});
        },

        routeClaimDetails(info) {
            if (info.receiptattach) {
                let stringh = info.receiptattach
                
                let ftypeHolder = stringh.match('application')
                let ftypeHolder2 = stringh.match('image')
                
                if (ftypeHolder == 'application') { info.filetype = 'PDF' } 
                if (ftypeHolder2 == 'image') { info.filetype = 'Image' }
            }
            info.receiptdate = moment(info.receiptdate).format('DD-MM-YYYY');
            this.$router.push({name: 'selfserviceclaimapprovaldetails', params: { item: info }});
        },

        loadClaimRecordDetails(param) {
            const vm = this;
            vm.loading = true;

            this.claimrecordItems = [];
            this.$store.dispatch('get', {url: "/wftrand/record/" + param + "/" + this.$store.getters.staffId})
            .then((res) => {
                const result = res.data

                if (result.status === 200) {
                    let item = result.rec

                    for (let i = 0; i < item.length; i++) {
                    item[i].entrytime = this.claimRecord.entrytime
                    item[i].reqstaffid = this.claimRecord.reqstaffid
                    item[i].maxreminder = this.claimRecord.maxreminder
                    item[i].wfdueactionid = this.claimRecord.wfdueactionid
                    item[i].remindnext = this.claimRecord.remindnext
                    item[i].level = this.claimRecord.level
                    item[i].hrlast = this.claimRecord.hrlast
                    item[i].exception = this.claimRecord.exception
                    let claimheader = this.claimrecordItems.filter(val => val.id  == item[i].clmtypeid)[0]

                    if (!claimheader) {
                        this.claimrecordItems.push({
                        id: item[i].clmtypeid,
                        clmtype: item[i].clmtype,
                        clmtypdesc: item[i].clmtypdesc,
                        clmrecordd: []
                        })
                    } 
                    item[i].displaydate = moment(item[i].receiptdate).format('DD-MM-YYYY')
                    item[i].active = false
                    let index = this.claimrecordItems.findIndex(val => val.id == item[i].clmtypeid)
                    this.claimrecordItems[index].clmrecordd.push(item[i])
                    }

                }

            vm.loading = false;

            }).catch((err) => {
                vm.loading = false;
                console.error(err)
            });
        }
    },

    mounted() {

        // From my claim approval page on load data
        if(this.$route.params.item) {
            this.claimRecord = this.$route.params.item
            this.loadClaimRecordDetails(this.claimRecord.wftranid)
            console.log('claimRecord', this.claimRecord)
        }

        // From my claim approval details page on load data (Back Button Claim Approval Details )
        if(this.$route.params.itemfromapprovaldetails) {
            this.claimRecord = this.$route.params.itemfromapprovaldetails
            this.loadClaimRecordDetails(this.claimRecord.wftranid)
        }

        // this.claimRecord = this.$route.params.item;
        // this.claimRecord = this.$route.params.itemfromapprovaldetails;

    }
}

</script>

<style scoped>
.ca-back-bar {
    padding: 14px 16px 10px 16px;
    border-bottom: 1px solid #F1F5F9;
}
.ca-scroll-content {
    height: calc(100vh - 175px);
    overflow-y: auto;
    padding: 16px;
}
.ca-scroll-content::-webkit-scrollbar { width: 6px; }
.ca-scroll-content::-webkit-scrollbar-track { background: #F8FAFF; }
.ca-scroll-content::-webkit-scrollbar-thumb { background: #C7D2FE; border-radius: 3px; }
</style>